import React from 'react';
import { connect } from 'react-redux';
import { StatusCritical, StatusWarning } from '_components';
import { codeTimed } from '_helpers';
import styles from './Common.module.css'

class ComputedCharges extends React.Component {

    render() {
        return (
            <div className={styles.computed_charges_wrapper}>
                <div className={styles.row}>
                    <span className={styles.time_label}>Total Minutes of Timed Therapy:</span>
                    <span className={styles.time}>{this.props.totalTimedMin}</span>
                </div>
                <div className={styles.row}>
                    <span className={styles.time_label}>Total Treatment Time:</span>
                    <span className={styles.time}>{this.props.totalTreatMin}</span>
                </div>
                <div className={styles.row}>
                    <div className={styles.diag_section_wrapper}>
                        <span className={styles.header_wrapper}>
                            <span className={styles.header_row}>
                                <span className={styles.header_col1}>Charges that will be generated:</span>
                            </span>
                        </span>

                        {Object.keys(this.props.computedChargesBill)
                            .map(id => {
                                const charge = this.props.computedChargesBill[id];
                                return (
                                    <div key={charge.CCNO}>
                                        {
                                            charge.CCTRTCODE + ' - ' +
                                            charge.RTDESC + ' - ' +
                                            charge.CCUNITS + ' ' +
                                            (charge.CCUNITS === 1 ? 'Unit' : 'Units') + ' ' +
                                            (codeTimed(charge.CCTRTCODE) ? 'Timed' : 'Untimed') +
                                            ' Code'
                                            + (charge.CCASSIST ? ' (Assistant)' : '')
                                        }
                                    </div>
                                )
                            })
                        }



                    </div>
                    <div className={styles.copy_wrapper} />
                    <div className={styles.diag_section_wrapper}>
                        <span className={styles.header_wrapper}>
                            <span className={styles.header_row}>
                                <span className={styles.header_col1}>Charges that will NOT be generated:</span>
                            </span>
                        </span>
                        {Object.keys(this.props.computedChargesNoBill)
                            .map(id => {
                                const charge = this.props.computedChargesNoBill[id];
                                return (
                                    <div key={charge.CCNO}>
                                        {
                                            charge.CCTRTCODE + ' - ' +
                                            charge.RTDESC + ' - ' +
                                            charge.CCUNITS + ' ' +
                                            (charge.CCUNITS === 1 ? 'Unit' : 'Units') + ' ' +
                                            (codeTimed(charge.CCTRTCODE) ? 'Timed' : 'Untimed') +
                                            ' Code'
                                            + (charge.CCASSIST ? ' (Assistant)' : '')
                                        }
                                    </div>
                                )
                            })
                        }

                    </div>
                </div>

                <div className={styles.error_wrapper}>
                    {this.props.errors && this.props.errors.map(key => {
                        return (
                            <div key={key} className={styles.error_row}>
                                <StatusCritical size='extra-small' />&nbsp;&nbsp;
                                {key}
                            </div>
                        )
                    })}
                    {this.props.warnings && this.props.warnings.map(key => {
                        return (
                            <div key={key} className={styles.error_row}>
                                <StatusWarning size='extra-small' />&nbsp;&nbsp;
                                {key}
                            </div>
                        )
                    })}
                </div>

            </div>
        );
    }

}


function parseHtmlString(html) {
    // <html><UL><LI>Aetna-OptumHealth authorized visits remaining is 2</LI><LI>Some other warning</LI></UL></html>
    html = html.substring(14, html.length - 17);
    return html.split('</LI><LI>');
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));
    let totalTimedMin = state.entities.notes.MLEXLOG[xlno].XLTOTALTIMEDMIN;
    let totalTreatMin = state.entities.notes.MLEXLOG[xlno].XLTOTALTREATMIN;

    let chargeRequest = state.entities.notes.MLCHARGEREQUESTS[Object.keys(state.entities.notes.MLCHARGEREQUESTS)
        .find(key => state.entities.notes.MLCHARGEREQUESTS[key].CRXLNO === xlno)];
    let computedChargesBill = Object.keys(state.entities.notes.MLCOMPUTEDCHARGES)
        .filter(key => state.entities.notes.MLCOMPUTEDCHARGES[key].CCCRNO === chargeRequest.CRNO &&
            state.entities.notes.MLCOMPUTEDCHARGES[key].CCBILLABLE === true)
        .sort((a, b) => state.entities.notes.MLCOMPUTEDCHARGES[a].CCNO - state.entities.notes.MLCOMPUTEDCHARGES[b].CCNO)
        .map(key => state.entities.notes.MLCOMPUTEDCHARGES[key]);
    let computedChargesNoBill = Object.keys(state.entities.notes.MLCOMPUTEDCHARGES)
        .filter(key => state.entities.notes.MLCOMPUTEDCHARGES[key].CCCRNO === chargeRequest.CRNO &&
            state.entities.notes.MLCOMPUTEDCHARGES[key].CCBILLABLE === false)
        .sort((a, b) => state.entities.notes.MLCOMPUTEDCHARGES[a].CCNO - state.entities.notes.MLCOMPUTEDCHARGES[b].CCNO)
        .map(key => state.entities.notes.MLCOMPUTEDCHARGES[key]);

    let warnings = undefined;
    let errors = undefined;

    if (chargeRequest.CRUSERWARNING) {
        warnings = parseHtmlString(chargeRequest.CRUSERWARNING);
    }
    if (chargeRequest.CRUSERERROR) {
        errors = parseHtmlString(chargeRequest.CRUSERERROR);
    }


    return {
        chargeRequest,
        computedChargesBill,
        computedChargesNoBill,
        totalTimedMin,
        totalTreatMin,
        warnings,
        errors
    };
}

const connectedComputedCharges = connect(mapStateToProps)(ComputedCharges);
export { connectedComputedCharges as ComputedCharges };

